// Home.js – Assemblage Bodas & Mas, Assemblage Weddings & More
// Home.js – Assemblage


import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations as en } from '../translations/en';
import { translations as es } from '../translations/es';
import destinationsData from '../data/destinationsData';
import testimonialsData from '../data/testimonialsData';
import HeroSection from '../components/home/HeroSection';
import AboutSection from '../components/home/AboutSection';
import ExperienceSection from '../components/home/ExperienceSection';
import ResortPackagesSection from '../components/home/ResortPackagesSection';
import CTASection from '../components/home/CTASection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import DestinationCarousel from '../components/DestinationCarousel';
import FullBleedImage from '../components/FullBleedImage';

const translations = { en, es };

export default function Home() {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="min-h-screen bg-[#181c24]">
      <HeroSection t={t} />
      
      {/* Destination Carousel */}
      <section className="py-6 md:py-20 px-4 md:px-0 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-playfair text-center text-[#181c24]">
          {t.destinations.title}
        </h2>
          <p className="text-xs md:text-sm mb-4 text-center text-[#181c24]/70 font-light max-w-2xl mx-auto">
          {t.destinations.viewAll}
        </p>
      <DestinationCarousel destinations={destinationsData} language={language} />
          {/* Top Venues Button - gold, premium, centered, now inside carousel section */}
          <div className="flex justify-center my-6">
            <a
              href="/resources/guides/top-venues"
              className="inline-block bg-[#bfa76a] hover:bg-[#a68d5d] text-white font-playfair text-lg md:text-xl font-semibold px-8 py-3 rounded-full shadow transition-all duration-200 text-center justify-center"
              style={{ letterSpacing: '0.01em' }}
            >
              {language === 'es' ? 'Descubre Nuestros 10 Mejores Venues en México' : 'Discover Our Top 10 Venues in Mexico'}
            </a>
          </div>
        </div>
      </section>

      <AboutSection t={t} language={language} />
      <ExperienceSection t={t} language={language} />
      
      <CTASection t={t} />
      <TestimonialsSection t={t} language={language} testimonialsData={testimonialsData} />
      <FullBleedImage 
        src="/images/party2.jpg"
        alt="A lively wedding celebration"
        className="h-56 md:h-96"
        objectPosition="center 50%"
      />
    </div>
  );
}
